import type { AdminJsonComponentConfig } from '@apps/websiteCustomJsonComponents/JsonComponent.types';
import { loadable } from '@shared/core/loadableFromNamedExport';
import { FormDisplayGrabber } from './FormDisplaySidebar';
import { FORM_DISPLAY_SCHEMA_URL, FORM_DISPLAY_COMPONENT_TYPE } from './FormDisplay.constants';

// Lazy load view components
const FormDisplayAdd = loadable(() => import(/* webpackChunkName: "content/websiteEditorFormDisplayAdd" */ './FormDisplaySidebar'), 'FormDisplayAdd');

const FormDisplayEdit = loadable(() => import(/* webpackChunkName: "content/websiteEditorFormDisplayEdit" */ './components/FormDisplayEdit'), 'FormDisplayEdit');

export const FormDisplayConfig: AdminJsonComponentConfig = {
  schemaUrl: FORM_DISPLAY_SCHEMA_URL,
  componentType: FORM_DISPLAY_COMPONENT_TYPE,
  adminSidebarComponent: {
    addComponentView: FormDisplayAdd,
    dragComponentView: FormDisplayGrabber,
    editComponentView: FormDisplayEdit,
    createComponentView: FormDisplayEdit,
  },
};
